var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarIconAwesomeHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.691,
    height: 23.691,
    viewBox: "0 0 23.691 23.691",
    fill: "#cae7f1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-history",
    "data-name": "Icon awesome-history",
    d: "M24.254,12.386a11.846,11.846,0,0,1-19.28,9.245,1.146,1.146,0,0,1-.088-1.7l.538-.538A1.148,1.148,0,0,1,6.948,19.3,8.789,8.789,0,1,0,6.387,6L8.811,8.429a.764.764,0,0,1-.54,1.3H1.327a.764.764,0,0,1-.764-.764V2.025a.764.764,0,0,1,1.3-.54L4.225,3.843a11.846,11.846,0,0,1,20.028,8.543Zm-8.641,3.763.469-.6a1.146,1.146,0,0,0-.2-1.609l-1.944-1.512V7.441A1.146,1.146,0,0,0,12.79,6.294h-.764A1.146,1.146,0,0,0,10.88,7.441V13.92L14,16.35a1.146,1.146,0,0,0,1.609-.2Z",
    transform: "translate(-0.563 -0.563)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconAwesomeHistory);
export default __webpack_public_path__ + "static/media/Sidebar-Icon-awesome-history.6a69d2e2c0131eeaa07e933e80724e14.svg";
export { ForwardRef as ReactComponent };